/**
 * API client for the eval-results trend endpoint (admin backend, Phase 3).
 *
 * Cross-institution; reads the eval_runs store written by evaluate_audit.py.
 */

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8001';

export async function fetchEvalRuns(type = 'audit', limit = 50) {
  const res = await fetch(`${API_URL}/api/eval-runs?type=${encodeURIComponent(type)}&limit=${limit}`);
  if (!res.ok) throw new Error(`Failed to fetch eval runs: ${res.status}`);
  return res.json();
}

export async function fetchOptimizerTelemetry(days = 30) {
  const res = await fetch(`${API_URL}/api/optimizer-telemetry?days=${days}`);
  if (!res.ok) throw new Error(`Failed to fetch optimizer telemetry: ${res.status}`);
  return res.json();
}
